import React, {useEffect, useState} from "react";
import InfoTooltip from "../tooltips/InfoTooltip";
import {Field, useForm, useFormState} from "react-final-form";
import ApplyField from "../fields/ApplyField";
import {checkWriterId} from "../../actions/ApplyFieldActions";
import {useDispatch, useSelector} from "react-redux";
import useApplyFieldData from "../../hooks/useApplyFieldData";
import {setPreferredWriterRatio} from "../../actions/OrderOptionActions";
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function PreferredWriter() {
    const {writerLevel} = useSelector(state => state.orderOptions.data);
    const {ratio} = useApplyFieldData('preferredWriter');
    const dispatch = useDispatch();
    const {change} = useForm();
    const {values} = useFormState();
    const [isFieldVisible, setIsFieldVisible] = useState(false);

    useEffect(() => {
        const savedPreferredWriter = QueryStorage.get("preferredWriter");
        if (savedPreferredWriter) {
            change("preferredWriter", savedPreferredWriter);
            toggleFieldVisibility();
            onClickRemove();
            checkWriterId();
        }
    }, [change]);

    const handleRadioChange = () => {
        values.freeAuthorCategory = undefined;
    };

    useEffect(() => {
        if (ratio) {
            dispatch(setPreferredWriterRatio(ratio));
            change('authorCategory', writerLevel.preferredWriter.value);
        }
    }, [ratio]);

    useEffect(() => {
        if (values.preferredWriter) {
            QueryStorage.set("preferredWriter", values.preferredWriter);
        } else {
            QueryStorage.remove("preferredWriter");
        }
    }, [values.preferredWriter]);

    const onClickRemove = () => {
        dispatch(setPreferredWriterRatio(0));
        Object.keys(writerLevel).map(key => {
            if (writerLevel[key].checked) {
                change('authorCategory', writerLevel[key].value);
                change('freeAuthorCategory', undefined);
            }
        });
    };

    const toggleFieldVisibility = () => {
        setIsFieldVisible(prevState => !prevState);
    };

    return <div className="form-group">
        <div className="pref-wrt-id-box">
            <div className="form-label pref-wrt-id-label" onClick={toggleFieldVisibility} style={{cursor: 'pointer'}}>
                <span style={{marginRight: '4px', marginTop: '1px'}}>
                    {isFieldVisible ?
                        <img src="/_core/assets/themes/v5/assets/img/form3/wrt-minus.svg" alt="minus-icon"/> :
                        <img src="/_core/assets/themes/v5/assets/img/form3/wrt-plus.svg" alt="plus-icon"/>
                    }
                </span>
                Preferred writer's ID
            </div>
            <InfoTooltip>
                <p>
                    Ask our support team for the ID of the writer that completed an order that you particularly liked.
                    Please note that the price will depend on the category of your writer.
                </p>
            </InfoTooltip>
        </div>
        {isFieldVisible && (
            <Field
                name="preferredWriter"
                title="Writer ID"
                component={ApplyField}
                placeholder="e.g. 653841"
                onClickApply={checkWriterId}
                onClickRemove={onClickRemove}
                removable={true}
                onClick={handleRadioChange}
                errorMessage="Please enter a valid writer ID"
            />
        )}
    </div>
}

export default PreferredWriter;
